import { WishlistsQuery } from "@apps/wishlist/queries/WishlistsQuery";
import { WishlistsService } from "@apps/wishlist/services/WishlistsService";

import { WishlistsStackQueryWrapper } from "./WishlistsStackQueryWrapper";
import { WishlistsStackServiceWrapper } from "./WishlistsStackServiceWrapper";

export class WishlistsStack {
    public readonly query: WishlistsStackQueryWrapper;
    public readonly service: WishlistsStackServiceWrapper;

    constructor(
        wishlistsQuery: WishlistsQuery,
        wishlistsService: WishlistsService
    ) {
        this.query = new WishlistsStackQueryWrapper(wishlistsQuery);
        this.service = new WishlistsStackServiceWrapper(
            wishlistsService,
            wishlistsQuery
        );
    }
}
